import { useEffect, useState } from 'react'
import { Tour } from 'antd'
import type { TourProps } from 'antd'

const STORAGE_KEY = 'aits-onboarding-v1'

interface OnboardingTourProps {
  forceOpen?: boolean
  onClose?: () => void
}

function findEl(selector: string): HTMLElement | null {
  return document.querySelector(selector)
}

export function OnboardingTour({ forceOpen, onClose }: OnboardingTourProps) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (forceOpen) {
      setOpen(true)
      return
    }
    const seen = localStorage.getItem(STORAGE_KEY)
    if (!seen) {
      const t = setTimeout(() => setOpen(true), 600)
      return () => clearTimeout(t)
    }
  }, [forceOpen])

  const steps: TourProps['steps'] = [
    {
      title: 'Chào mừng đến với PK-KQ',
      description: (
        <div>
          <div className="mb-2">Hệ thống ứng dụng & CSDL phục vụ Đề án CĐS Quân chủng Phòng không – Không quân giai đoạn 2026-2030.</div>
          <div className="text-[11px] opacity-70">Tour 5 bước để làm quen các phân hệ chính.</div>
        </div>
      ),
      target: () => findEl('.ant-layout-sider')!,
    },
    {
      title: 'Sở chỉ huy',
      description: 'Màn hình tổng hợp single-screen cho lãnh đạo: KPI realtime, bản đồ tactical, alerts feed, lịch bay, thời tiết. Hỗ trợ chế độ fullscreen TV.',
      target: () => findEl('.ant-menu-item[data-menu-id$="sch"]') ?? findEl('.ant-layout-sider')!,
    },
    {
      title: '6 phân hệ nghiệp vụ',
      description: (
        <div>
          <div className="mb-1">Tác chiến · Kế hoạch bay · Dẫn đường · Vận tải · Khí tượng · Báo động.</div>
          <div className="text-[11px] opacity-70">Mỗi phân hệ có Dashboard + nhiều màn chuyên sâu.</div>
        </div>
      ),
      target: () => findEl('.ant-menu')!,
    },
    {
      title: 'Tìm kiếm toàn cục',
      description: (
        <div>
          <div className="mb-1">Nhấn <kbd className="px-1.5 py-0.5 rounded bg-slate-700 text-[10px] font-mono">Ctrl+K</kbd> bất cứ lúc nào để tìm trang, KHB, phi công, máy bay, mục tiêu...</div>
        </div>
      ),
      target: () => findEl('.ant-layout-header button[title*="Tìm"]') ?? findEl('.ant-layout-header')!,
    },
    {
      title: 'Trung tâm thông báo',
      description: 'Cảnh báo realtime + thông báo phê duyệt + đồng bộ BQP. Click chuông để xem và navigate đến đúng nơi xử lý.',
      target: () => findEl('.ant-layout-header .ant-popover-open, .ant-layout-header .ant-badge') ?? findEl('.ant-layout-header')!,
    },
    {
      title: 'Sẵn sàng!',
      description: (
        <div>
          <div className="mb-1">Anh có thể mở lại tour này bất kỳ lúc nào tại <strong>Admin → Help</strong>.</div>
          <div className="text-[11px] opacity-70">Chúc anh có một phiên làm việc hiệu quả!</div>
        </div>
      ),
      target: () => findEl('.ant-layout-header')!,
    },
  ]

  function handleClose() {
    setOpen(false)
    localStorage.setItem(STORAGE_KEY, '1')
    onClose?.()
  }

  return <Tour open={open} onClose={handleClose} steps={steps} mask={{ color: 'rgba(0,0,0,0.7)' }} />
}

export function resetOnboarding() {
  localStorage.removeItem(STORAGE_KEY)
}
